import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './CookieConsent.css'

const CONSENT_KEY = 'ls-cookie-consent'
const GA_MEASUREMENT_ID = 'G-0NBFKW1MPG'

declare global {
  interface Window {
    dataLayer: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

// Load Google Analytics only after the visitor has accepted analytics cookies.
function loadAnalytics() {
  if (document.getElementById('ga-gtag-js')) return
  const script = document.createElement('script')
  script.id = 'ga-gtag-js'
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  const gtag = (...args: unknown[]) => {
    window.dataLayer.push(args)
  }
  window.gtag = gtag
  gtag('js', new Date())
  gtag('config', GA_MEASUREMENT_ID)
}

function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    let choice: string | null = null
    try {
      choice = localStorage.getItem(CONSENT_KEY)
    } catch {
      // localStorage unavailable (private mode, etc.) — show banner, load nothing
    }
    if (choice === 'accepted') {
      loadAnalytics()
    } else if (choice !== 'declined') {
      setVisible(true)
    }
  }, [])

  const persist = (value: 'accepted' | 'declined') => {
    try {
      localStorage.setItem(CONSENT_KEY, value)
    } catch {
      // ignore write failures
    }
    setVisible(false)
  }

  const accept = () => {
    persist('accepted')
    loadAnalytics()
  }

  const decline = () => {
    persist('declined')
  }

  if (!visible) return null

  return (
    <div className="cookie-consent" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <p className="cookie-consent-text">
        We use cookies to analyze site traffic and improve your experience. Accept analytics cookies
        or decline—essential cookies always stay on. See our{' '}
        <Link to="/privacy" className="cookie-consent-link">Privacy Policy</Link>.
      </p>
      <div className="cookie-consent-actions">
        <button type="button" className="cookie-consent-btn cookie-consent-decline" onClick={decline}>
          Decline
        </button>
        <button type="button" className="cookie-consent-btn cookie-consent-accept" onClick={accept}>
          Accept
        </button>
      </div>
    </div>
  )
}

export default CookieConsent
